import React from 'react';
import { Filter, DisabledInput, List, Edit, Create, SimpleForm,
  Datagrid, TextField, TextInput, EditButton, Responsive,
  SimpleList,  ReferenceInput,
    SelectInput } from 'react-admin';


export const CoordinadorFilter = (props) => (
  <Filter {...props}>
   <TextInput label="Nombre" source="searchnombre" autoFocus alwaysOn />
   <TextInput label="Usuario" source="searchdni" autoFocus />
   <TextInput label="Etapa" source="searchetapa" autoFocus />
  </Filter>
);

const CoordinadorNameEdit = ({ record }) => {
  return (
    <Responsive small={
      <span>
        Editar Coordinador
      </span>
    }
    medium={
      <span>
        Editar Coordinador: {record ? `"${record.nombre}"` : ''}
      </span>
    }
    />

  );
};

export const CoordinadorEdit = (props) => (
    <Edit title={<CoordinadorNameEdit />} {...props}>
        <SimpleForm>
          <TextInput label="Nombre y Apellido" source="nombre" />
          <DisabledInput label="Usuario" source="dni" />
          <ReferenceInput reference="etapas" source="etapa" perPage={100} sort={{ field: 'nombre', order: 'ASC' }}>
              <SelectInput  optionText="nombre" optionValue="nombre" />
          </ReferenceInput>
          <TextInput label="Contraseña" source="validacion" type="password" />
        </SimpleForm>
    </Edit>
);

export const CoordinadorCreate = (props) => (
    <Create title="Registrar Coordinador" {...props}>
        <SimpleForm redirect="/coordinadores">
          <TextInput label="Nombre y Apellido" source="nombre" />
          <TextInput label="Usuario" source="dni" />
          <ReferenceInput reference="etapas" source="etapa" perPage={100} sort={{ field: 'nombre', order: 'ASC' }}>
              <SelectInput  optionText="nombre" optionValue="nombre" />
          </ReferenceInput>
          <TextInput label="Contraseña" source="validacion" type="password" />
        </SimpleForm>
    </Create>
);

export const EditableCoordinadorList = (props) => (
    <List
      {...props}
      bulkActions={false}
      filters={<CoordinadorFilter />}
      exporter={false}
      sort={{ field: "nombre", order: "ASC" }}
    >
    <Responsive small={
      <SimpleList
          primaryText={record => record.nombre}
          secondaryText={record => 'Etapa: ' + record.etapa}
          tertiaryText={record => 'Usuario: ' + record.dni}
      />
    }
    medium={
      <Datagrid>
          <TextField source="nombre" />
          <TextField source="dni" label="Usuario" />
          <TextField source="etapa" />
          <EditButton />
      </Datagrid>
    }
    />
    </List>
);



// WEBPACK FOOTER //
// ./src/services/coordinadores.js